module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-132.78fa9b92.jpg";